<template>
    <div>
        <div class="category-list" v-if="this.$root.hide_categories === ''">
            <ul class="uk-grid-collapse" uk-grid>
<!--                <li><a href="#" :class="{ 'cat-link active' : cat_id === false, 'cat-link' : cat_id !== false }" title="Alles" @click.prevent="setList(false)">Alles</a></li>-->
                <li v-for="(category, key) in this.$root.list"><a :class="{ 'cat-link active' : cat_id === key, 'cat-link' : cat_id !== key }" href="#" :title="category.title" @click.prevent="setList(key)">{{ category.title }}</a></li>
            </ul>
        </div>

        <div class="article-list">
            <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-margin-medium uk-grid-match" uk-grid>
                <div v-for="(item, key) in list">
                    <item :title="item.title"
                        :image="item.image"
                        :slug="item.slug"
                        :key="item.id"
                        :translations="translations">
                    </item>
                </div>
            </div>
        </div>

<!--        <div class="category-more-links" v-if="this.$root.hide_categories === ''">-->
<!--            <ul class="uk-grid-collapse" uk-grid>-->
<!--                <li>{{ translations.bekijk_meer_fotoboeken_van }}:</li>-->
<!--                <li v-for="(category, key) in this.$root.list"><a :href="'/fotoboeken/cat/' + category.slug" :title="category.title">{{ category.title }}</a></li>-->
<!--            </ul>-->
<!--        </div>-->

        <div class="category-link" v-if="this.$root.category">
            <a :href="this.$root.category.link">{{ translations.zie_alle }} {{ this.$root.category.title }} {{ translations.fotoboeken }}</a>
        </div>
    </div>
</template>

<script>
    let item = {
        props: {
            'title': String,
            'image': String,
            'slug': String,
            'translations': {},
        },
        template: `<a class="article-link clearfix" :href="slug" :title="title">
<div class="imageholder" :style="{ backgroundImage: 'url(' + image + ')' }"></div>
    <div class="content">
        <div class="inner">
            <h2 class="title uk-text-left">{{ title }}</h2>
            <div class="link">{{ translations.zie_meer }}</div>
        </div>
    </div>
</a>
    `,
    }

    export default {
        data () {
            return {
                list: [],
                cat_id: false,
                hide_categories: false,
                translations: {},
            }
        },
        mounted: function () {
            this.setAll()
            this.translations = this.$root.translations
        },
        methods: {
            setAll () {
                var limit = 3;
                var i =1;
                for (const [key1, categories] of Object.entries(this.$root.list)) {
                    for (const [key2, value] of Object.entries(categories.items)) {
                        if (i <= 3) {
                            this.list.push(value)
                        }
                        i++;
                    }
                }
            },
            setList (id) {
                this.cat_id = id
                this.list = []

                if (id === false) {
                    return this.setAll()
                }

                var limit = 3;
                var i =1;
                for (const [key2, value] of Object.entries(this.$root.list[id].items)) {
                    if (i <= limit) {
                      this.list.push(value);
                    }
                    i++;
                }
            },
        },
        components: {
            item,
        },
    }
</script>
